import { useContext } from 'react'

import { PanelContext } from './PanelContext'

export const usePanelContext = () => {
  const context = useContext(PanelContext)

  if (!context)
    throw new Error(
      'You forgot to wrap your component in <PanelContextProvider>',
    )

  return context
}
